"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = logout;

var _oauth = _interopRequireDefault(require("./oauth"));

var _logoutCleanupRegistry = require("./logout-cleanup-registry");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function logout() {
  (0, _logoutCleanupRegistry.runLogoutCleanup)();
  window.location.href = _oauth["default"].getRevokeUrl();
}